import React from "react";

// P17-UAT-15 REV-B2A · derived per-entry consumption state badge (traceability
// only). Consumption is owned by a Product Weaving Consumption Run (WCR), shown
// on the dedicated Weaving Consumption view — the Loom Register only reflects
// each entry's derived state.
const META = {
  UNCONSUMED: { label: "Unconsumed", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/40" },
  PARTIALLY_CONSUMED: { label: "Partially Consumed", cls: "bg-amber-500/15 text-amber-300 border-amber-400/40" },
  CONSUMED: { label: "Consumed", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-400/40" },
};

export function ConsumptionStateBadge({ state }) {
  if (!state) return null;
  const m = META[state] || { label: state, cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/40" };
  return (
    <span data-testid={`consumption-state-${state}`}
      className={`ml-2 text-[9px] font-bold px-1 py-0.5 rounded-sm border uppercase tracking-widest align-middle ${m.cls}`}>
      {m.label}
    </span>
  );
}
